import { GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { createContext, MouseEvent } from 'react'
import { PaymentStatus } from 'src/constants/payment/enums'
import { MCPayment } from 'src/interfaces/mcPayment'

export interface IMCPaymentsTableContext {
  selectedRows: GridRowSelectionModel
  setSelectedRows(rowSelectionModel: GridRowSelectionModel): void

  selectedMCPayments: Array<MCPayment>

  searchQuery: string
  setSearchQuery(value: string): void

  statusFilter: Array<PaymentStatus>
  setStatusFilter(statusFilter: Array<PaymentStatus>): void

  // edit action
  actionAnchor: null | HTMLElement
  paymentToAction: MCPayment | null
  openMCPaymentsItemAction(event: MouseEvent<HTMLButtonElement>, payment: MCPayment): void
  closeMCPaymentsItemAction(): void
  clearMCPaymentsItemAction(): void
}

export const MCPaymentsTableContext = createContext<IMCPaymentsTableContext>({
  selectedRows: [],
  setSelectedRows: () => {},

  selectedMCPayments: [],

  searchQuery: '',
  setSearchQuery: () => {},

  statusFilter: [],
  setStatusFilter: () => {},

  actionAnchor: null,
  paymentToAction: null,
  openMCPaymentsItemAction: () => {},
  closeMCPaymentsItemAction: () => {},
  clearMCPaymentsItemAction: () => {},
})
